import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

const styles = makeStyles(() => ({
  uploadModal: {
    maxWidth: "744px",

    "& #bodyContainer": {
      margin: 0,
    },

    "& #bodyContent": {
      padding: 0,
    },

    "& button[data-cy='button-cancel']": {
      color: colors.gray800,
      fontFamily: "Manrope",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: 600,
      letterSpacing: "0.1px",
      lineHeight: "20px",
      textAlign: "center",
    },

    "& button[data-cy='button-save']": {
      fontFamily: "Manrope",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: 600,
      letterSpacing: "0.1px",
      lineHeight: "20px",
      textAlign: "center",
    },

    "& #dropBtn": {
      border: `1px dashed ${colors.gray200}`,
      borderRadius: "12px",
    },

    "& #modalBody": {
      margin: 0,
      padding: "24px",
    },

    "& #modalFooter": {
      background: colors.white,
      borderRadius: "0px 0px 12px 12px",
      borderTop: `1px solid ${colors.gray200}`,
    },
  },
}));

export default styles;
